<body>
  <app-nav-menu [hidden]="isCustCorp"></app-nav-menu>
  <div class="container" [ngClass]="isPatentPlusUser ? 'patent-plus-section' : ''">
    <router-outlet></router-outlet>
  </div>
</body>
